import RemoveToast from 'actions/toast/remove_toast';
import Toast from 'models/toast';

export default class ShowToast {
  constructor(context) {
    this.context = context;
  }

  run({ id, type, message, link }) {
    const toast = Toast.create({ id, type, message, link });
    this.context.stores.toasts.addOrReplace(toast);
    RemoveToast.schedule(this.context, { id: toast.id });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/toast/show_toast.js